((holidayBundleSliders, $) => {
  "use strict";

  const $dom = {};

  const cacheDom = () => {
    $dom.holidayBundleTopTiles = $(".js-holiday-bundle-top--tiles-slider");
    $dom.holidayBundleStockingSlider = $(
      ".js-holiday-bundle-stocking-stuffer-slider"
    );
    $dom.holidayBundleCollectionSlider = $("[data-holiday-colelction-slider]");
  };

  const bindUIActions = () => {
    $dom.holidayBundleTopTiles.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false
          }
        }
      ]
    });

    $dom.holidayBundleStockingSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });

    $dom.holidayBundleCollectionSlider.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  holidayBundleSliders.init = init;
})((window.holidayBundleSliders = window.holidayBundleSliders || {}), jQuery);
